<template>
  <div>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" width="40%">File</th>
            <th></th>
            <th class="text-left" width="30%"><v-badge dot title="Il valore è modificabile" offset-x="-2" offset-y="4" >Descrizione</v-badge></th>
            <th class="text-left">Data</th>
            <th class="text-left">Dimensione</th>
            <th class="text-center" width="4%"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(file, i) in elenco" :key="i" height="50">
            <!-- <td>{{file.name}}</td> -->
            <td><a :href="file.pathFile">{{file.name}}</a></td>
            <td >
              <v-img :src="file.pathFile" max-width="50"></v-img>
            </td>
            <!-- <td>{{file.description}}</td> -->
            <td>
              <v-edit-dialog :return-value.sync="file.description" large persistent cancel-text="Annulla" save-text="Salva" @save="onSaveDescription(file)">
                <span width="300px">{{ file.description }}</span>
                <template v-slot:input>
                  <v-select v-model="utilizzo" class="mt-5" :items="utilizzoImmagini" item-text="descrizione" item-value="codice" label="Utilizzo immagine" return-object></v-select>
                </template>
              </v-edit-dialog>
            </td>            
            <td>{{file.lastModified | date}}</td>
            <td>{{file.size | fileSize}}</td>
            <td><v-icon title="Cancella il file" @click="onRemoveFile(file)">mdi-delete-outline</v-icon></td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>    
    <dialog-conferma
      :show="dialogConferma"
      :title="titoloConferma"
      :message="messaggioConferma"
      @dialog-confirm="onConferma"
      @dialog-cancel="dialogConferma=false"
    />
  </div>
</template>

<script>
import DialogConferma from '@/components/dialogConferma'
import configurazioni from '@/services/configurazioniService'

export default {
  components: {
    DialogConferma
  },
  props: {
    files: Array,
    moduli: Array
  },
  data(vm) {
    return {
      dialogConferma: false,
      titoloConferma: '',
      messaggioConferma: '',
      onConferma: vm.onRemoveFile,
      itemToDelete: null,
      elenco: [],
      utilizzoImmagini: [],
      utilizzo: null
    }
  },
  watch: {
    files() {
      this.elenco = this.files
    }
  },
  async mounted() {
    const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
    this.utilizzoImmagini = _.get(impostazioni, 'prodotti.immagini.utilizzo') || []
  },
  methods: {
    onSaveDescription(file) {
      file.description = _.cloneDeep(this.utilizzo)
      this.$emit('change', file)
    },
    onRefresh() {
      this.$emit('refresh')
    }, 
    onRemoveFile(item) {
      this.titoloConferma = "Cancellazione file"
      this.messaggioConferma = 'Confermi la cancellazione del file ?'
      this.onConferma = this.removeFile
      this.itemToDelete = item
      this.dialogConferma = true
    },
    removeFile() {
      const item = this.itemToDelete
      this.$emit('delete', item)
      this.itemToDelete = null
      this.dialogConferma = false
    } 
  }
}
</script>
